<template>
  <div class="d-tag">
    <div class="d-tag__text">{{tag}}</div>
    <div class="icon-cross2 d-tag__icon"
         @click="remove(tag)">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tag: {
        type: String,
        default: ''
      }
    },
    methods: {
      remove () {
        this.$emit('remove', this.tag)
      }
    }
  }
</script>

<style scoped>
  .d-tag {
    display: flex;
    align-items: center;
    padding: 1px 5px;
    border-radius: 4px;
    background: #f6f8f9;
    border: 1px solid #e0e6e8;
    color: #333;
    border: 1px solid #c8d6e2;
    background: #f6f9fc;
    font-size: 13px;
    font-weight: 500;
    transition: background-color .02s;
  }

  .d-tag__text {
    padding: 0 5px;
  }

  .d-tag__icon {
    font-size: 11px;
    border: 1px solid transparent;
    border-radius: 50%;
    padding: 2px;
    cursor: pointer;
    transition: background-color .25s, color .25s;
  }

  .d-tag__icon:hover {
    background: #888;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// Tag.vue?268ae81a